<template>
  <div>
    <div>
      <a :href="downloadFiles[$i18n.locale]" class="link-download" target="_blank">{{$t('medium_grant.budget__1_download_template')}}
        <img class="ml-2" width="25" src="/img/icons/xls.png"> </a>
      <p class="mt-3">{{$t('medium_grant.budget__1_info')}}</p>
    </div>

    <upload-file v-if="GrantForm.initialized" v-model="GrantForm.files.budget.revisionTemplate" :size-limit="GrantForm.fileSizeLimit" :file-data="GrantForm.files.budget.revisionTemplate" :is-editable="GrantForm.isRevisionEditable" section="budget.revisionTemplate">
      <div class="row">
        <div class="font-icon-list col-lg-12">
          <div class="font-icon-detail application-button">
            <img width="100" class="xls-icon-big" src="/img/icons/xls.png">
            <h4>{{$t('medium_grant.budget__1_upload_xls')}}</h4>
          </div>
        </div>
      </div>
    </upload-file>

    <div class="row">
      <div class="col-lg-12">
        <h4 class="card-title mt-4">{{$t('medium_grant.revised_document_upload__other_budget_documents_card_title')}}</h4>
        <p>{{$t('medium_grant.document_upload__other_documents_info')}}</p>
        <table class="mt-5 mb-2" width="100%">
          <thead>
            <th>Name</th>
            <th>Upload</th>
          </thead>
          <tbody>
            <tr v-for="(item, index) in GrantForm.revisionModel.technical.otherBudgetDocuments" :key="'result_'+index">
              <td>
                <textarea
                  class="form-control"
                  :placeholder="$t('medium_grant.revised_document_upload__other_budget_documents_placeholder')"
                  v-model="item.result"
                >
                </textarea>
              </td>
              <td>
                <upload-file
                  v-if="GrantForm.initialized"
                  v-model="GrantForm.files.technical['otherBudgetDocuments' + (index+1)]"
                  class="upload-file"
                  :file-data="GrantForm.files.technical['otherBudgetDocuments' + (index+1)]"
                  :is-editable="GrantForm.isRevisionEditable"
                  :size-limit="GrantForm.fileSizeLimit"
                  :section="'technical.otherBudgetDocuments' + (index + 1)"
                  >
                </upload-file>
              </td>
            </tr>
          </tbody>
        </table>

        <base-button
          type="primary"
          @click.native="addOtherDocument"
          class="ml-2"
          >
          <i class="tim-icons icon-simple-add mr-2"></i> {{$t('medium_grant.logical_framework__add_row_button_title')}}
        </base-button>
        <span class="ml-3">{{$t('medium_grant.logical_framework__add_row_button_info')}}</span>
      </div>
    </div>

  </div>
</template>
<script>
  import {GrantForm} from "@/services";

  export default {
    data() {
      return {
        GrantForm,
        downloadFiles: {
          en: '/files/en/BIOPAMA_AC_MG_budget_template.xls',
          fr: '/files/fr/FR_BIOPAMA_AC_MG_budget_template.xls'
        }
      }
    },
    methods:
    {
      addOtherDocument()
      {
        if (!GrantForm.revisionModel.technical.otherBudgetDocuments)
        {
          GrantForm.revisionModel.technical.otherBudgetDocuments = [];
        }

        GrantForm.revisionModel.technical.otherBudgetDocuments.push({});
        this.$forceUpdate();
      },
    }
  }
</script>
<style lang="scss" scoped>
  a {
    color: black;

    &:hover {
      text-decoration: underline;
    }
  }
</style>
